import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';
import { confirmationMap } from './ConfirmationPageSelectors';
import {
  selectAdvisors,
  mapData,
} from '../../../../../selectors/globalSelectors';

export const selectViewGAPurpose = (state) => {
  const { purpose } = confirmationMap(state);
  return purpose;
};

export const selectViewGrantRecognition = (state) => {
  const { grantRecognition } = confirmationMap(state);
  return grantRecognition;
};

export const selectViewGAGranteeOrg = (state) => {
  const { granteeOrg } = confirmationMap(state);
  return granteeOrg;
};

export const selectViewGrantAgreementId = (state) => {
  const { grantAgreementId } = confirmationMap(state);
  return grantAgreementId;
};

export const selectConfirmationPool = (state) => {
  const { confirmationPool } = fetchGAWState(state);
  return confirmationPool;
};

export const selectPayments = (state) => {
  const { paymentInformation } = confirmationMap(state);
  if (paymentInformation && paymentInformation.payment) {
    return paymentInformation.payment;
  }
  return [];
};

export const selectViewGAStartDate = (state) => {
  const { gaStartDate } = confirmationMap(state);
  return gaStartDate;
};

export const selectViewGAEndDate = (state) => {
  const { gaEndDate } = confirmationMap(state);
  return gaEndDate;
};

export const selectViewGAStatus = (state) => {
  const { status } = confirmationMap(state);
  return status;
};

export const selectViewGrantAgreementAmount = (state) => {
  const { grantAgreementAmount } = confirmationMap(state);
  return grantAgreementAmount;
};

export const selectViewGANoOfPayments = (state) => {
  const { noOfPayments } = confirmationMap(state);
  return noOfPayments;
};

export const viewGrantAgreementDerivedStates = createStructuredSelector({
  purpose: selectViewGAPurpose,
  recognition: selectViewGrantRecognition,
  contact: selectViewGAGranteeOrg,
  grantAgreementId: selectViewGrantAgreementId,
  investments: selectConfirmationPool,
  payments: selectPayments,
  startDate: selectViewGAStartDate,
  endDate: selectViewGAEndDate,
  status: selectViewGAStatus,
  grantAgreementAmount: selectViewGrantAgreementAmount,
  noOfPayments: selectViewGANoOfPayments,
  advisors: selectAdvisors,
  codeValueMappingData: mapData,
});
